"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AiModelConfigSchema = exports.AiReasoningSummarySchema = exports.AiReasoningSummary = exports.AiModelEffortSchema = exports.AiModelSchema = exports.AnthropicAiModelSchema = exports.GoogleGenAiModelSchema = exports.GoogleGenAiModel = exports.OpenAiModelSchema = void 0;
exports.getModelEnum = getModelEnum;
exports.supportsReasoningEffortParameter = supportsReasoningEffortParameter;
const zod_1 = require("zod");
const model_cards_1 = require("./model-cards");
exports.OpenAiModelSchema = zod_1.z.nativeEnum(model_cards_1.OpenAiModel);
var GoogleGenAiModel;
(function (GoogleGenAiModel) {
    GoogleGenAiModel["gemini_3_1_pro_preview"] = "gemini-3.1-pro-preview";
    GoogleGenAiModel["gemini_2_5_pro"] = "gemini-2.5-pro";
    GoogleGenAiModel["gemini_2_5_flash"] = "gemini-2.5-flash";
    GoogleGenAiModel["gemini_2_5_flash_lite"] = "gemini-2.5-flash-lite";
})(GoogleGenAiModel || (exports.GoogleGenAiModel = GoogleGenAiModel = {}));
exports.GoogleGenAiModelSchema = zod_1.z.nativeEnum(GoogleGenAiModel);
exports.AnthropicAiModelSchema = zod_1.z.nativeEnum(model_cards_1.AnthropicAiModel);
exports.AiModelSchema = zod_1.z.union([
    exports.OpenAiModelSchema,
    exports.GoogleGenAiModelSchema,
    exports.AnthropicAiModelSchema,
]);
exports.AiModelEffortSchema = zod_1.z.nativeEnum(model_cards_1.AiModelEffort);
var AiReasoningSummary;
(function (AiReasoningSummary) {
    AiReasoningSummary["concise"] = "concise";
    AiReasoningSummary["detailed"] = "detailed";
})(AiReasoningSummary || (exports.AiReasoningSummary = AiReasoningSummary = {}));
exports.AiReasoningSummarySchema = zod_1.z.nativeEnum(AiReasoningSummary);
exports.AiModelConfigSchema = zod_1.z.object({
    model: exports.AiModelSchema,
    temperature: zod_1.z.number().optional(),
    topP: zod_1.z.number().optional(),
    effort: exports.AiModelEffortSchema.optional(),
    reasoningSummary: exports.AiReasoningSummarySchema.optional(),
    maxOutputTokens: zod_1.z.number().optional(),
});
function getModelEnum(model) {
    if (Object.values(model_cards_1.OpenAiModel).includes(model)) {
        return model_cards_1.OpenAiModel;
    }
    if (Object.values(GoogleGenAiModel).includes(model)) {
        return GoogleGenAiModel;
    }
    if (Object.values(model_cards_1.AnthropicAiModel).includes(model)) {
        return model_cards_1.AnthropicAiModel;
    }
    return null;
}
function supportsReasoningEffortParameter(model) {
    if (!Object.values(model_cards_1.OpenAiModel).includes(model)) {
        return false;
    }
    return (0, model_cards_1.getOpenAiModelCard)(model).reasoning?.parameter === 'reasoning.effort';
}
//# sourceMappingURL=ai-model-config.js.map